/* eslint-disable no-plusplus */
/* eslint-disable consistent-return */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-param-reassign */
/* eslint-disable no-return-assign */
/* eslint-disable react/prop-types */
/* eslint-disable indent */
/* eslint-disable no-shadow */
/* eslint-disable react/require-default-props */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component, useEffect } from 'react';
import axios from 'axios';
import _ from 'underscore';
import PropTypes from 'prop-types';

// HELPERS
import Chart from 'react-apexcharts';
import { isMobile } from 'react-device-detect';
import moment from 'moment';
// REDUX
import { connect } from 'react-redux';
import * as elementsActions from '../../redux/actions/elements';
import * as dataActions from '../../redux/actions/data';

// COMPONENTS
import Header from '../../components/Header/Header';
import Navigation from '../../components/Navigation/Navigation';
import ToTop from '../../components/ToTop/ToTop';
import LargeCarousel from '../../components/LargeCarousel/LargeCarousel';
import SmallCarousel from '../../components/SmallCarousel/SmallCarousel';
import Filter from '../../components/Filter/Filter';
import Graph from '../../components/Graph/Graph';
import ScoreCard from '../../components/ScoreCard/ScoreCard';
import GraphData from '../../components/GraphData/GraphData';
import Loader from '../../components/Loader/Loader';

// SUB PAGE UI
import Alerts from '../Alerts/Alerts';

// STATIC DATA
import {
  headlineCards,
  watchListCards,
  mySalesSeries,
  mySalesTable,
  myShareSeries,
  myShareTable,
  monthDateRange,
  weekDateRange,
} from './data';

// GRAPH OPTIONS
import { heroBarGraphOptions, heroLineGraphOptions } from './graphs';

// SUB UI HELPERS
import {
  returnHeadlinesDates,
  returnHeroHeader,
  renderHeroCard,
  renderGraph,
} from './renderings';

import styles from './Home.module.scss';

const shareButton = require('./imgs/icons/share-button.svg');

// PLACEHOLDER ASSET
const shareAsset = require('./imgs/share-asset.png');
const noteCardAsset = require('./imgs/note-card-asset.png');
const learnMoreAsset = require('./imgs/learn-more-asset.png');

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showOverlay: false,
      showShare: false,
      showCard: false,
      isNavOpen: false,
      showAlerts: false,
      showLearnMore: false,
      showGraphData: false,
      graphData: {
        title: null,
        highlightColor: null,
      },
      marketTop5: true,
      shareTop5: true,
      totalSharesGraph: [],
      totalShares: [],
      totalSalesGraph: [],
      totalSales: [],
      loading: false,
      salesDrivers: {
        plotData: [],
        salesTrendTables: [],
        dateRange: [],
      },
      marketShare: {
        marketSalesTable: {
          top5SalesTrendTables: [],
          top5SalesPlotData: [],
          closest5SalesPlotData: [],
          closest5SalesTrendTables: [],
        },
        marketSharesTable: {
          top5SharesTrendTables: [],
          top5SharesPlotData: [],
          closest5SharesPlotData: [],
          closest5SharesTrendTables: [],
        },
      },
      topPerformers: [],
    };
    this.marketViewSection = React.createRef();
  }

  /**
   * Handles state animation setting & finished callback animation setting
   * @param {State Object} primaryObject
   * @param {State Object} secondaryObject
   * @param {Number} timeout
   */
  handleAnimation = (primaryObject, secondaryObject, timeout) => {
    this.setState(primaryObject, () =>
      setTimeout(() => this.setState(secondaryObject), timeout)
    );
  };

  /**
   * Handles overlay animation
   */
  showOverlay = () => {
    const { showOverlay, renderOverlay } = this.state;
    this.handleAnimation(
      !showOverlay
        ? { showOverlay: !showOverlay }
        : { renderOverlay: !renderOverlay },
      !showOverlay
        ? { renderOverlay: !renderOverlay }
        : { showOverlay: !showOverlay },
      !showOverlay ? 100 : 300
    );
  };

  /**
   * Toggle navigation UIz
   */
  toggleNav = () => {
    const { isNavOpen, showOverlay, renderNav } = this.state;
    window.scrollTo(0, 0); // eslint-disable-line
    // handle overlay UI
    this.showOverlay();
    // handle nav UI
    this.handleAnimation(
      !isNavOpen ? { isNavOpen: !isNavOpen } : { renderNav: !renderNav },
      !isNavOpen ? { renderNav: !renderNav } : { isNavOpen: !isNavOpen },
      !showOverlay ? 100 : 300
    );
  };

  /**
   * Handles overlay children animation
   */
  handleOverlayAnimation = (state) => {
    // eslint-disable-next-line react/destructuring-assignment
    if (!this.state[state]) {
      // eslint-disable-line
      this.showOverlay();
      setTimeout(() => this.setState({ [state]: true }), 50);
    } else {
      this.setState({ [state]: false });
      setTimeout(this.showOverlay, 100);
    }
  };

  toggleAlerts = () => {
    const { showAlerts, isNavOpen } = this.state;
    this.setState({ showAlerts: !showAlerts });
    if (isNavOpen) setTimeout(() => this.toggleNav(), 400);
  };

  handleDataClick = (graphData) => {
    this.handleOverlayAnimation('showGraphData');
    this.setState({ graphData });
  };

  homeContainer = () => {
    const {
      isNavOpen,
      renderNav,
      showShare,
      showOverlay,
      renderOverlay,
      showCard,
      showAlerts,
      showGraphData,
      graphData,
      showLearnMore,
      totalSalesLoading,
      totalSharesLoading,
      salesDriversLoading,
      marketSalesLoading,
      topPerformersLoading,
      marketTop5,
      shareTop5,
    } = this.state;

    console.log(this.state.salesDrivers.dateRange);

    const { filterObject, setStoredData, storedData } = this.props;
    useEffect(() => {
      const { filterObject } = this.props;
      const { timePeriod, portfolio, viewBy } = filterObject;
      const { history, viewCheck } = this.props;
      // RUN USER AGENT CHECK
      if (!isMobile && viewCheck) return history.push('/warning');
      // MAIN LOGIC

      setTimeout(() => {
        const { setMarketViewPosition } = this.props;
        const { top } = this.marketViewSection.current.getBoundingClientRect();
        setMarketViewPosition(top + window.pageYOffset); // eslint-disable-line
      }, 500);

      // Grab Filters
      const fetchFilters = async () => {
        await axios
          .get(
            'https://marketshareapi.ascentialedge.com/clients/57e2c60a19e4a/portfolio_filters',
            { headers: { 'x-api-key': process.env.REACT_APP_API_KEY } }
          )
          // Grabs all portfolio filters and sets global redux value to use in Filters.jsx
          .then((response) => {
            // For some reason my declaration of this.props in line 75
            // isn't in this block scope, had to declare it here
            // const { setFilterObject, filterObject } = this.props;
            const { setAllPortfolioFilters } = this.props;
            setAllPortfolioFilters([
              { name: 'All Portfolios', uuid: '' },
              ...response.data.data,
            ]);
          })
          .then(() => this.setState({ loading: false }));
      };

      fetchFilters();

      const fetchData = async () => {
        await this.setState({
          totalSalesLoading: true,
          totalSharesLoading: true,
          salesDriversLoading: true,
          marketSalesLoading: true,
          topPerformersLoading: true,
        });
        // // You can await here
        axios
          .get(
            `https://marketshareapi.ascentialedge.com/clients/57e2c60a19e4a/reports/sales_period_cumulative?start_date=${
              timePeriod.start
            }&end_date=${
              timePeriod.end
            }&rollup=month&include_vat=0&view_by=manufacturer${
              portfolio.uuid ? `&filter_uuid=${portfolio.uuid}` : ''
            }${viewBy ? `&view_by=${viewBy}` : ''}`,
            { headers: { 'x-api-key': process.env.REACT_APP_API_KEY } }
          )
          .then((res) => {
            console.log('TOTAL SALES/SHARES DATA =========>  ', res);

            const condensedSalesData = res.data.data.filter(
              (el) => el.sales_type === 'Total'
            );
            const totalSalesGraph = [];
            condensedSalesData.forEach((el) => {
              totalSalesGraph.push(el.accumulated_sales);
            });
            this.setState({
              totalSalesGraph,
              totalSales: res.data.data,
              totalSalesLoading: false,
            });
            setStoredData({
              ...this.state,
            });
          });

        // Shares Data
        axios
          .get(
            `https://marketshareapi.ascentialedge.com/clients/57e2c60a19e4a/reports/my_share_chart?start_date=${
              timePeriod.start
            }&end_date=${timePeriod.end}&rollup=month&include_vat=0${
              portfolio.uuid ? `&filter_uuid=${portfolio.uuid}` : ''
            }${viewBy ? `&view_by=${viewBy}` : ''}`,
            { headers: { 'x-api-key': process.env.REACT_APP_API_KEY } }
          )
          .then((response) => {
            const totalSharesGraph = [];
            response.data.data.forEach((el) => {
              totalSharesGraph.push(el.share);
            });
            this.setState({
              totalSharesGraph,
              totalShares: response.data.data,
              totalSharesLoading: false,
            });
            setStoredData({
              ...this.state,
            });
          });

        // Sales Drivers Data
        axios
          .get(
            `https://marketshareapi.ascentialedge.com/clients/57e2c60a19e4a/reports/my_sales_drivers?start_date=${
              timePeriod.start
            }&end_date=${timePeriod.end}&rollup=${
              timePeriod.name === 'This Quarter' ||
              timePeriod.name === 'Last Quarter'
                ? 'week'
                : 'month'
            }&include_vat=0${
              portfolio.uuid ? `&filter_uuid=${portfolio.uuid}` : ''
            }${viewBy ? `&view_by=${viewBy}` : ''}`,
            { headers: { 'x-api-key': process.env.REACT_APP_API_KEY } }
          )
          .then((salesDriverResponse) => {
            console.log('SALES DRIVERS DATA =========>  ', salesDriverResponse);

            const { data } = salesDriverResponse.data;
            const filteredData = data.filter(
              (el) =>
                el.trend !== undefined &&
                el.value !== undefined &&
                el.trend !== null &&
                el.value !== null
            );

            // Sales
            const salesDriversData =
              timePeriod.name === 'This Quarter' ||
              timePeriod.name === 'Last Quarter'
                ? filteredData
                    .filter(
                      (salesDriver) =>
                        salesDriver.group === 'Sales' &&
                        salesDriver.trend !== undefined &&
                        salesDriver.value !== undefined &&
                        salesDriver.trend !== null &&
                        salesDriver.value !== null
                    )
                    .slice(-12)
                : filteredData.filter(
                    (salesDriver) =>
                      salesDriver.group === 'Sales' &&
                      salesDriver.trend !== undefined &&
                      salesDriver.value !== undefined &&
                      salesDriver.trend !== null &&
                      salesDriver.value !== null
                  );

            const dateRange = salesDriversData.reduce((datesArray, driver) => {
              datesArray.push(
                `${moment(driver.period_start).format(
                  'MMM Do YYYY'
                )} - ${moment(driver.period_end).format('MMM Do YYYY')}`
              );
              return datesArray;
            }, []);

            const salesDriversPlotData = salesDriversData.reduce(
              (salesDriversArray, driver) => {
                if (driver.trend !== undefined && driver.trend !== null) {
                  salesDriversArray.push(driver.trend);
                }
                return salesDriversArray;
              },
              []
            );

            // Conversion
            const conversionDrivers =
              timePeriod.name === 'This Quarter' ||
              timePeriod.name === 'Last Quarter'
                ? filteredData
                    .filter(
                      (conversionDriver) =>
                        conversionDriver.group === 'Conversion Rate' &&
                        conversionDriver.trend !== undefined &&
                        conversionDriver.value !== undefined &&
                        conversionDriver.trend !== null &&
                        conversionDriver.value !== null
                    )
                    .slice(-12)
                : filteredData.filter(
                    (conversionDriver) =>
                      conversionDriver.group === 'Conversion Rate' &&
                      conversionDriver.trend !== undefined &&
                      conversionDriver.value !== undefined &&
                      conversionDriver.trend !== null &&
                      conversionDriver.value !== null
                  );

            const conversionDriversPlotData = conversionDrivers.reduce(
              (conversionDriversArray, driver) => {
                if (driver.trend !== undefined && driver.trend !== null) {
                  conversionDriversArray.push(driver.trend);
                }
                return conversionDriversArray;
              },
              []
            );

            // Traffic a.k.a. Page Views
            const trafficDrivers =
              timePeriod.name === 'This Quarter' ||
              timePeriod.name === 'Last Quarter'
                ? filteredData
                    .filter(
                      (trafficDriver) =>
                        trafficDriver.group === 'Page Views' &&
                        trafficDriver.trend !== undefined &&
                        trafficDriver.value !== undefined &&
                        trafficDriver.trend !== null &&
                        trafficDriver.value !== null
                    )
                    .slice(-12)
                : filteredData.filter(
                    (trafficDriver) =>
                      trafficDriver.group === 'Page Views' &&
                      trafficDriver.trend !== undefined &&
                      trafficDriver.value !== undefined &&
                      trafficDriver.trend !== null &&
                      trafficDriver.value !== null
                  );
            const trafficDriversPlotData = trafficDrivers.reduce(
              (trafficDriversArray, driver) => {
                if (driver.trend !== undefined && driver.trend !== null) {
                  trafficDriversArray.push(driver.trend);
                }
                return trafficDriversArray;
              },
              []
            );

            // Shares
            const sharesDrivers =
              timePeriod.name === 'This Quarter' ||
              timePeriod.name === 'Last Quarter'
                ? filteredData
                    .filter(
                      (sharesDriver) =>
                        sharesDriver.group === 'Share' &&
                        sharesDriver.trend !== undefined &&
                        sharesDriver.value !== undefined &&
                        sharesDriver.trend !== null &&
                        sharesDriver.value !== null
                    )
                    .slice(-12)
                : filteredData.filter(
                    (sharesDriver) =>
                      sharesDriver.group === 'Share' &&
                      sharesDriver.trend !== undefined &&
                      sharesDriver.value !== undefined &&
                      sharesDriver.trend !== null &&
                      sharesDriver.value !== null
                  );
            const sharesDriversPlotData = sharesDrivers.reduce(
              (sharesDriversArray, driver) => {
                if (driver.trend !== undefined && driver.trend !== null) {
                  sharesDriversArray.push(driver.trend);
                }
                return sharesDriversArray;
              },
              []
            );

            const salesTrendTables = [];

            for (let i = 0; i < salesDriversData.length; i++) {
              salesTrendTables.push([
                {
                  title: 'Sales',
                  value: salesDriversData[i]
                    ? `$${(salesDriversData[i].value * 0.000001).toFixed(3)}M`
                    : 'N/A',
                  percentChange: salesDriversData[i]
                    ? salesDriversData[i].trend.toFixed(1)
                    : 'N/A',
                },
                {
                  title: 'Conversion',
                  value: conversionDrivers[i]
                    ? `${(conversionDrivers[i].value * 10).toFixed(2)}%`
                    : 'N/A',
                  percentChange: conversionDrivers[i]
                    ? conversionDrivers[i].trend.toFixed(1)
                    : 'N/A',
                },
                {
                  title: 'Traffic',
                  value: trafficDrivers[i]
                    ? `${(trafficDrivers[i].value * 0.0000007).toFixed(
                        2
                      )}M Views`
                    : 'N/A',
                  percentChange: trafficDrivers[i]
                    ? trafficDrivers[i].trend.toFixed(1)
                    : 'N/A',
                },
                {
                  title: 'Share',
                  value: sharesDrivers[i]
                    ? `${(sharesDrivers[i].value * 100).toFixed(1)}%`
                    : 'N/A',
                  percentChange: sharesDrivers[i]
                    ? sharesDrivers[i].trend.toFixed(1)
                    : 'N/A',
                },
              ]);
            }

            this.setState({
              salesDrivers: {
                // Data for the salesDrivers graphs
                dateRange,
                salesTrendTables,
                plotData: [
                  { data: salesDriversPlotData },
                  { data: conversionDriversPlotData },
                  { data: trafficDriversPlotData },
                  { data: sharesDriversPlotData },
                ],
              },
              salesDriversLoading: false,
            });

            setStoredData({
              ...this.state,
            });
          });

        axios
          .get(
            `https://marketshareapi.ascentialedge.com/clients/57e2c60a19e4a/reports/top_items?start_date=${timePeriod.start}&end_date=${timePeriod.end}&number_of_items=10&include_vat=0`,
            { headers: { 'x-api-key': process.env.REACT_APP_API_KEY } }
          )
          .then((res) => {
            console.log('TOP PERFORMERS DATA =========>  ', res);
            const topPerformers = res.data.data.top_performers_by_sales;
            const topPerformersCards = topPerformers.map((performer) => ({
              company: performer.title,
              totalNumber: `$${(performer.sales * 0.000001).toFixed(3)}M`,
              totalPercentage: `${(performer.share * 100).toFixed(1)}%`,
              totalPercentageYoY: `${(performer.share_difference * 100).toFixed(
                1
              )}`,
            }));

            this.setState({
              topPerformers: topPerformersCards,
              topPerformersLoading: false,
            });
            setStoredData({
              ...this.state,
            });
          });

        axios
          .get(
            `https://marketshareapi.ascentialedge.com/clients/57e2c60a19e4a/reports/sales_share_period_competitive?start_date=${
              timePeriod.start
            }&end_date=${timePeriod.end}&rollup=${
              timePeriod.name === 'This Quarter' ||
              timePeriod.name === 'Last Quarter'
                ? 'week'
                : 'month'
              // {
              // "error": "The number of comps may not be greater than 10.\n"
              // }
            }&number_of_comps=10&include_vat=0${
              portfolio.uuid ? `&filter_uuid=${portfolio.uuid}` : ''
            }${viewBy ? `&view_by=${viewBy}` : ''}`,
            { headers: { 'x-api-key': process.env.REACT_APP_API_KEY } }
          )
          .then((res) => {
            console.log('MARKETVIEW DATA =========>   ', res);

            const salesMarketData = res.data.data.sales_both
              ? res.data.data.sales_both
              : [];

            const data = _.groupBy(salesMarketData, 'group');
            delete data.Total;
            delete data['All Other'];

            const dataArray = Object.values(data);

            const dateRange = dataArray[0]
              ? dataArray[0].map((el) => {
                  return `${moment(el.period_start).format(
                    'MMM Do YYYY'
                  )} - ${moment(el.period_end).format('MMM Do YYYY')}`;
                })
              : [];

            const rankedSalesData = _.sortBy(
              data,
              (x) => x[x.length - 1].value
            ).reverse();

            const rankedSharesData = _.sortBy(
              data,
              (x) => x[x.length - 1].share
            ).reverse();

            const top5SalesGroups = rankedSalesData.slice(0, 5);

            const top5SharesGroups = rankedSharesData.slice(0, 5);

            const myClientName = Object.keys(data)[0];

            const mySalesRankIndex = rankedSalesData.findIndex(
              (el) => el[0].group === myClientName
            );

            const mySharesRankIndex = rankedSharesData.findIndex(
              (el) => el[0].group === myClientName
            );

            let closest5SalesGroups = [];

            if (mySalesRankIndex < 0) {
              closest5SalesGroups = [];
            } else if (mySalesRankIndex === 0 || mySalesRankIndex === 1) {
              closest5SalesGroups = rankedSalesData.slice(0, 5);
            } else if (
              mySalesRankIndex === rankedSalesData.length - 1 ||
              mySalesRankIndex === rankedSalesData.length - 2
            ) {
              closest5SalesGroups = rankedSalesData.slice(-5);
            } else {
              closest5SalesGroups = rankedSalesData
                .slice(mySalesRankIndex - 2, mySalesRankIndex)
                .concat(
                  rankedSalesData.slice(mySalesRankIndex, mySalesRankIndex + 3)
                );
            }

            let closest5SharesGroups = [];

            if (mySharesRankIndex === 0 || mySharesRankIndex === 1) {
              closest5SharesGroups = rankedSharesData.slice(0, 5);
            } else if (
              mySharesRankIndex === rankedSharesData.length - 1 ||
              mySharesRankIndex === rankedSharesData.length - 2
            ) {
              closest5SharesGroups = rankedSharesData.slice(-5);
            } else {
              closest5SharesGroups = rankedSharesData
                .slice(mySharesRankIndex - 2, mySharesRankIndex)
                .concat(
                  rankedSharesData.slice(
                    mySharesRankIndex,
                    mySharesRankIndex + 3
                  )
                );
            }

            const top5SalesPlotData = top5SalesGroups.map((eachRank) => ({
              data: eachRank.map((rank) => rank.value),
            }));

            const top5SharesPlotData = top5SharesGroups.map((eachRank) => ({
              data: eachRank.map((rank) => rank.share),
            }));

            const closest5SalesPlotData = closest5SalesGroups.map(
              (eachRank) => ({
                data: eachRank.map((rank) => rank.value),
              })
            );

            const closest5SharesPlotData = closest5SharesGroups.map(
              (eachRank) => ({
                data: eachRank.map((rank) => rank.share),
              })
            );

            const closest5SalesHash = {};

            for (let i = 0; i < closest5SalesGroups.length; i++) {
              for (let x = 0; x < closest5SalesGroups[i].length; x++) {
                if (
                  !closest5SalesHash[closest5SalesGroups[i][x].period_start]
                ) {
                  closest5SalesHash[closest5SalesGroups[i][x].period_start] = [
                    {
                      title: closest5SalesGroups[i][x].group,
                      value: closest5SalesGroups[i][x].value
                        ? (closest5SalesGroups[i][x].value * 0.000006).toFixed(
                            3
                          )
                        : 'N/A',
                      percentChange: closest5SalesGroups[i][x].woy_change
                        ? (closest5SalesGroups[i][x].woy_change * 10).toFixed(1)
                        : 'N/A',
                    },
                  ];
                } else {
                  closest5SalesHash[
                    closest5SalesGroups[i][x].period_start
                  ].push({
                    title: closest5SalesGroups[i][x].group,
                    value: closest5SalesGroups[i][x].value
                      ? (closest5SalesGroups[i][x].value * 0.000006).toFixed(3)
                      : 'N/A',
                    percentChange: closest5SalesGroups[i][x].woy_change
                      ? (closest5SalesGroups[i][x].woy_change * 10).toFixed(1)
                      : 'N/A',
                  });
                }
              }
            }

            const closest5SharesHash = {};

            for (let i = 0; i < closest5SharesGroups.length; i++) {
              for (let x = 0; x < closest5SharesGroups[i].length; x++) {
                if (
                  !closest5SharesHash[closest5SharesGroups[i][x].period_start]
                ) {
                  closest5SharesHash[
                    closest5SharesGroups[i][x].period_start
                  ] = [
                    {
                      title: closest5SharesGroups[i][x].group,
                      value: closest5SharesGroups[i][x].share
                        ? (closest5SharesGroups[i][x].share * 100).toFixed(1)
                        : 'N/A',
                      percentChange: closest5SharesGroups[i][x]
                        .share_last_year_difference
                        ? (
                            closest5SharesGroups[i][x]
                              .share_last_year_difference * 100
                          ).toFixed(1)
                        : 'N/A',
                    },
                  ];
                } else {
                  closest5SharesHash[
                    closest5SharesGroups[i][x].period_start
                  ].push({
                    title: closest5SharesGroups[i][x].group,
                    value: closest5SharesGroups[i][x].share
                      ? (closest5SharesGroups[i][x].share * 100).toFixed(1)
                      : 'N/A',
                    percentChange: closest5SharesGroups[i][x]
                      .share_last_year_difference
                      ? (
                          closest5SharesGroups[i][x]
                            .share_last_year_difference * 100
                        ).toFixed(1)
                      : 'N/A',
                  });
                }
              }
            }

            const top5SalesHash = {};

            for (let i = 0; i < top5SalesGroups.length; i++) {
              for (let x = 0; x < top5SalesGroups[i].length; x++) {
                if (!top5SalesHash[top5SalesGroups[i][x].period_start]) {
                  top5SalesHash[top5SalesGroups[i][x].period_start] = [
                    {
                      title: top5SalesGroups[i][x].group,
                      value: top5SalesGroups[i][x].value
                        ? (top5SalesGroups[i][x].value * 0.000006).toFixed(3)
                        : 'N/A',
                      percentChange: top5SalesGroups[i][x].woy_change
                        ? (top5SalesGroups[i][x].woy_change * 10).toFixed(1)
                        : 'N/A',
                    },
                  ];
                } else {
                  top5SalesHash[top5SalesGroups[i][x].period_start].push({
                    title: top5SalesGroups[i][x].group,
                    value: top5SalesGroups[i][x].value
                      ? (top5SalesGroups[i][x].value * 0.000006).toFixed(3)
                      : 'N/A',
                    percentChange: top5SalesGroups[i][x].woy_change
                      ? (top5SalesGroups[i][x].woy_change * 10).toFixed(1)
                      : 'N/A',
                  });
                }
              }
            }

            const top5SharesHash = {};

            for (let i = 0; i < top5SharesGroups.length; i++) {
              for (let x = 0; x < top5SharesGroups[i].length; x++) {
                if (!top5SharesHash[top5SharesGroups[i][x].period_start]) {
                  top5SharesHash[top5SharesGroups[i][x].period_start] = [
                    {
                      title: top5SharesGroups[i][x].group,
                      value: top5SharesGroups[i][x].share
                        ? (top5SharesGroups[i][x].share * 100).toFixed(1)
                        : 'N/A',
                      percentChange: top5SharesGroups[i][x]
                        .share_last_year_difference
                        ? (
                            top5SharesGroups[i][x].share_last_year_difference *
                            100
                          ).toFixed(1)
                        : 'N/A',
                    },
                  ];
                } else {
                  top5SharesHash[top5SharesGroups[i][x].period_start].push({
                    title: top5SharesGroups[i][x].group,
                    value: top5SharesGroups[i][x].share
                      ? (top5SharesGroups[i][x].share * 100).toFixed(1)
                      : 'N/A',
                    percentChange: top5SharesGroups[i][x]
                      .share_last_year_difference
                      ? (
                          top5SharesGroups[i][x].share_last_year_difference *
                          100
                        ).toFixed(1)
                      : 'N/A',
                  });
                }
              }
            }

            const top5SharesTrendTables = Object.values(top5SharesHash);
            const top5SalesTrendTables = Object.values(top5SalesHash);
            const closest5SalesTrendTables = Object.values(closest5SalesHash);
            const closest5SharesTrendTables = Object.values(closest5SharesHash);

            const marketShare = {
              dateRange,
              marketSalesTable: {
                top5SalesTrendTables,
                top5SalesPlotData,
                closest5SalesPlotData,
                closest5SalesTrendTables,
              },
              marketSharesTable: {
                top5SharesTrendTables,
                top5SharesPlotData,
                closest5SharesPlotData,
                closest5SharesTrendTables,
              },
            };
            this.setState({
              marketShare,
              marketSalesLoading: false,
            });
            setStoredData({
              ...this.state,
            });
          });
      };
      return this.setState({ loading: true }, fetchData);
    }, [this.props.filterObject]);

    const totalSales =
      Array.isArray(this.state.totalSales) && this.state.totalSales.length > 0
        ? this.state.totalSales
        : storedData.totalSales;

    const totalSalesGraph =
      Array.isArray(this.state.totalSalesGraph) &&
      this.state.totalSalesGraph.length > 0
        ? this.state.totalSalesGraph
        : storedData.totalSalesGraph;

    const totalShares =
      Array.isArray(this.state.totalShares) && this.state.totalShares.length > 0
        ? this.state.totalShares
        : storedData.totalShares;

    const totalSharesGraph =
      Array.isArray(this.state.totalSharesGraph) &&
      this.state.totalSharesGraph.length > 0
        ? this.state.totalSharesGraph
        : storedData.totalSharesGraph;

    const salesDrivers =
      this.state.salesDrivers !== undefined &&
      Array.isArray(this.state.salesDrivers.plotData) &&
      this.state.salesDrivers.plotData.length > 0 &&
      Array.isArray(this.state.salesDrivers.salesTrendTables) &&
      this.state.salesDrivers.salesTrendTables.length > 0 &&
      Array.isArray(this.state.salesDrivers.dateRange) &&
      this.state.salesDrivers.dateRange.length > 0
        ? this.state.salesDrivers
        : storedData.salesDrivers;

    const marketShare =
      this.state.marketShare &&
      this.state.marketShare.marketSalesTable &&
      this.state.marketShare.marketSharesTable &&
      Array.isArray(
        this.state.marketShare.marketSalesTable.top5SalesTrendTables
      ) &&
      this.state.marketShare.marketSalesTable.top5SalesTrendTables.length > 0
        ? this.state.marketShare
        : storedData.marketShare;

    const topPerformers =
      Array.isArray(this.state.topPerformers) &&
      this.state.topPerformers.length > 0
        ? this.state.topPerformers
        : storedData.topPerformers;

    const { timePeriod } = filterObject;

    const topSalesLoaded = totalSales && totalSales.length > 0;

    const topSharesLoaded = totalShares && totalShares.length > 0;

    const marketTopSalesUpperBound =
      Array.isArray(marketShare.marketSalesTable.top5SalesTrendTables) &&
      marketShare.marketSalesTable.top5SalesTrendTables.length > 0 &&
      marketShare.marketSalesTable.top5SalesTrendTables[
        marketShare.marketSalesTable.top5SalesTrendTables.length - 1
      ][0].value !== undefined
        ? Math.ceil(
            marketShare.marketSalesTable.top5SalesTrendTables[
              marketShare.marketSalesTable.top5SalesTrendTables.length - 1
            ][0].value / 10
          ) * 10
        : '';

    const marketTopSharesUpperBound =
      Array.isArray(marketShare.marketSharesTable.top5SharesTrendTables) &&
      marketShare.marketSharesTable.top5SharesTrendTables.length > 0 &&
      marketShare.marketSharesTable.top5SharesTrendTables[
        marketShare.marketSharesTable.top5SharesTrendTables.length - 1
      ][0].value !== undefined
        ? Math.ceil(
            marketShare.marketSharesTable.top5SharesTrendTables[
              marketShare.marketSharesTable.top5SharesTrendTables.length - 1
            ][0].value
          )
        : '';

    const marketClosestSalesUpperBound =
      Array.isArray(marketShare.marketSalesTable.closest5SalesTrendTables) &&
      marketShare.marketSalesTable.closest5SalesTrendTables.length > 0 &&
      marketShare.marketSalesTable.closest5SalesTrendTables[
        marketShare.marketSalesTable.closest5SalesTrendTables.length - 1
      ][0].value !== undefined
        ? Math.ceil(
            marketShare.marketSalesTable.closest5SalesTrendTables[
              marketShare.marketSalesTable.closest5SalesTrendTables.length - 1
            ][0].value / 10
          ) * 10
        : '';

    const marketClosestSharesUpperBound =
      Array.isArray(marketShare.marketSharesTable.closest5SharesTrendTables) &&
      marketShare.marketSharesTable.closest5SharesTrendTables.length > 0 &&
      marketShare.marketSharesTable.closest5SharesTrendTables[
        marketShare.marketSharesTable.closest5SharesTrendTables.length - 1
      ][0].value !== undefined
        ? Math.ceil(
            marketShare.marketSharesTable.closest5SharesTrendTables[
              marketShare.marketSharesTable.closest5SharesTrendTables.length - 1
            ][0].value
          )
        : '';

    // Replaces componentDidMount and gets called everytime this.props is changed
    // UseEffect is Synchronous

    return (
      <div className={styles.homeWrapper}>
        {/* ALERTS PAGE */}
        <div
          className={[
            styles.alertsWrapper,
            showAlerts ? styles.showAlerts : null,
          ].join(' ')}
        >
          <Alerts toggleAlerts={this.toggleAlerts} />
        </div>
        {/* NAVIGATION */}
        {isNavOpen ? (
          <div
            className={[
              styles.navigationWrapper,
              renderNav ? styles.showNavigation : null,
            ].join(' ')}
          >
            <Navigation
              toggleAlerts={this.toggleAlerts}
              toggleNav={this.toggleNav}
            />
          </div>
        ) : null}
        {/* OVERLAY DIV */}
        {showOverlay ? (
          <div
            onClick={() => {
              if (!isNavOpen) {
                if (showCard) return this.handleOverlayAnimation('showCard');
                if (showLearnMore) {
                  return this.handleOverlayAnimation('showLearnMore');
                }
                if (showGraphData) {
                  return this.handleOverlayAnimation('showGraphData');
                }
                return this.handleOverlayAnimation('showShare');
              }
              return null;
            }}
            className={[
              styles.overlay,
              renderOverlay ? styles.renderOverlay : null,
            ].join(' ')}
          >
            <img
              className={showShare ? styles.showAsset : null}
              alt="share"
              id={styles.shareAsset}
              src={shareAsset}
            />
            <img
              className={showCard ? styles.showAsset : null}
              alt="share"
              id={styles.cardAsset}
              src={noteCardAsset}
            />
            <img
              className={showLearnMore ? styles.showAsset : null}
              alt="share"
              id={styles.cardAsset}
              src={learnMoreAsset}
            />
            <div
              id={styles.cardAsset}
              className={showGraphData ? styles.showAsset : null}
            >
              <GraphData graphData={graphData} />
            </div>
          </div>
        ) : null}
        <>
          {/* HEADER COMPONENT */}
          <Header toggleNav={this.toggleNav} isNavOpen={isNavOpen} />
          {/* PAGE BODY */}
          <div>
            {/* HERO SECTION */}
            <div>
              <Filter isStatic />
              <div className={styles.sectionContainer}>
                <div className={styles.cardsWrapper}>
                  {/* TODO: REPLACE STATIC DATA WITH API DATA */}
                  {renderHeroCard(
                    this,
                    'Total Sales',
                    topSalesLoaded
                      ? `$${(
                          totalSales[totalSales.length - 1].accumulated_sales *
                          0.000001
                        ).toFixed(3)}M`
                      : '',
                    topSalesLoaded
                      ? `${(
                          totalSales[totalSales.length - 1]
                            .yoy_accumulated_change * 10
                        ).toFixed(1)}`
                      : '',
                    <div className={styles.heroGraphs}>
                      <Chart
                        options={heroBarGraphOptions(totalSalesGraph)}
                        series={[{ data: totalSalesGraph }]}
                        type="bar"
                        width="100%"
                      />
                      {totalSalesLoading ? (
                        <div
                          style={{ top: totalSales.length > 0 ? '50%' : '55%' }}
                          className={styles.topGraphsLoader}
                        >
                          <Loader />
                        </div>
                      ) : null}
                    </div>
                  )}
                  {renderHeroCard(
                    this,
                    'Total Share',
                    topSharesLoaded
                      ? `${(
                          totalShares[totalShares.length - 1].share * 100
                        ).toFixed(1)}%`
                      : '',
                    topSharesLoaded
                      ? `${(
                          totalShares[totalShares.length - 1].share_yoy_change *
                          100
                        ).toFixed(1)}
                          `
                      : '',

                    <div className={styles.heroGraphs}>
                      <Chart
                        options={heroLineGraphOptions(totalSharesGraph)}
                        series={[{ data: totalSharesGraph }]}
                        type="line"
                        width="100%"
                      />
                      {totalSharesLoading ? (
                        <div
                          style={{
                            top: totalShares.length > 0 ? '50%' : '55%',
                          }}
                          className={styles.topGraphsLoader}
                        >
                          <Loader />
                        </div>
                      ) : null}
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* SCORECARD SECTION */}
            <div className={styles.scoreCardContainer}>
              <div className={styles.scoreCardHeader}>
                <p>SCORECARD</p>
                <img
                  onClick={() => this.handleOverlayAnimation('showShare')}
                  alt="share-button"
                  src={shareButton}
                />
              </div>
              {/* TODO: REPLACE IMAGE WITH DYNAMICALLY RENDERED ELEMENTS */}
              <ScoreCard />
              <p
                className={styles.learnMore}
                onClick={() => this.handleOverlayAnimation('showLearnMore')}
              >
                Learn More &gt;
              </p>
            </div>
            {/* HEADLINES SECTION */}
            <div className={styles.headlinesContainer}>
              <div className={styles.headlinesHeader}>
                <p>HEADLINES</p>
                {returnHeadlinesDates()}
              </div>
              {/* TODO: REPLACE STATIC DATA WITH API DATA */}
              <LargeCarousel
                onShare={() => this.handleOverlayAnimation('showShare')}
                cards={headlineCards}
              />
            </div>
            {/* MY SALES SECTION */}
            {renderGraph(
              this,
              'MY SALES',
              '$',
              <Graph
                firstColumn="Product Group"
                secondColumnPrimary="Sales"
                secondColumnSecondary="$ (M)"
                thirdColumnPrimary="YoY"
                thirdColumnSecondary="% Chg"
                seriesData={mySalesSeries}
                dateRangeType={
                  timePeriod.name === 'This Quarter' ||
                  timePeriod.name === 'Last Quarter'
                    ? 'week'
                    : 'month'
                }
                dateRange={
                  timePeriod.name === 'This Quarter' ||
                  timePeriod.name === 'Last Quarter'
                    ? weekDateRange
                    : monthDateRange
                }
                tableData={mySalesTable}
                upperBound="$50M"
                onDataClick={this.handleDataClick}
                onShare={() => this.handleOverlayAnimation('showCard')}
              />,
              null
            )}
            {/* MY SHARES SECTION */}
            {renderGraph(
              this,
              'MY SHARE',
              '%',
              <Graph
                firstColumn="Product Group"
                secondColumnPrimary="Share"
                secondColumnSecondary="%"
                thirdColumnPrimary="YoY"
                thirdColumnSecondary="% Chg"
                seriesData={myShareSeries}
                dateRange={
                  timePeriod.name === 'This Quarter' ||
                  timePeriod.name === 'Last Quarter'
                    ? weekDateRange
                    : monthDateRange
                }
                dateRangeType={
                  timePeriod.name === 'This Quarter' ||
                  timePeriod.name === 'Last Quarter'
                    ? 'week'
                    : 'month'
                }
                tableData={myShareTable}
                upperBound="30%"
                onDataClick={this.handleDataClick}
                onShare={() => this.handleOverlayAnimation('showCard')}
              />,
              null
            )}
            {/* TOP PERFORMERS SECTION */}
            <div className={styles.topPerformersContainer}>
              <div className={styles.topPerformersHeader}>
                <p>TOP PERFORMERS</p>
                <div>
                  <img
                    onClick={() => this.handleOverlayAnimation('showShare')}
                    alt="share-button"
                    src={shareButton}
                  />
                </div>
              </div>
              {topPerformers && topPerformers.length > 0 ? (
                <SmallCarousel
                  isLoading={topPerformersLoading}
                  cards={topPerformers}
                />
              ) : (
                <div className={styles.performersLoader}>
                  <Loader />
                </div>
              )}
            </div>
            {/* 1P SALES DRIVERS SECTION */}
            {renderGraph(
              this,
              'MY 1P SALES DRIVERS',
              'Indexed trend view',
              <div className={styles.primaryGraph}>
                <Graph
                  firstColumn="Driver"
                  secondColumnPrimary={null}
                  secondColumnSecondary={null}
                  thirdColumnPrimary="Period"
                  thirdColumnSecondary="% Trend"
                  dateRange={salesDrivers.dateRange}
                  seriesData={salesDrivers.plotData}
                  dateRangeType={
                    timePeriod.name === 'This Quarter' ||
                    timePeriod.name === 'Last Quarter'
                      ? 'week'
                      : 'month'
                  }
                  tableData={salesDrivers.salesTrendTables}
                  onDataClick={this.handleDataClick}
                  onShare={() => this.handleOverlayAnimation('showCard')}
                  isLoading={salesDriversLoading}
                />
              </div>,
              null
            )}
            {/* MARKET VIEW */}
            <div ref={this.marketViewSection} className={styles.heroContainer}>
              {returnHeroHeader('Market View')}
            </div>
            {/* MONEY SALES SECTION */}
            {renderGraph(
              this,
              'MARKET SALES',
              '$',
              <div className={styles.primaryGraph}>
                <Graph
                  firstColumn="Manufacturers"
                  secondColumnPrimary="Sales"
                  secondColumnSecondary="$(M)"
                  thirdColumnPrimary="YoY"
                  thirdColumnSecondary="% Chg"
                  dateRange={marketShare.dateRange}
                  dateRangeType={
                    timePeriod.name === 'This Quarter' ||
                    timePeriod.name === 'Last Quarter'
                      ? 'week'
                      : 'month'
                  }
                  seriesData={
                    marketTop5
                      ? marketShare.marketSalesTable.top5SalesPlotData
                      : marketShare.marketSalesTable.closest5SalesPlotData
                  }
                  tableData={
                    marketTop5
                      ? marketShare.marketSalesTable.top5SalesTrendTables
                      : marketShare.marketSalesTable.closest5SalesTrendTables
                  }
                  upperBound={`${
                    marketTop5
                      ? marketTopSalesUpperBound
                      : marketClosestSalesUpperBound
                  }M`}
                  onDataClick={this.handleDataClick}
                  onShare={() => this.handleOverlayAnimation('showCard')}
                  isLoading={marketSalesLoading}
                />
              </div>,
              'marketTop5'
            )}
            {/* SHARE SECTION */}
            {renderGraph(
              this,
              'MARKET SHARE',
              '%',
              <div className={styles.primaryGraph}>
                <Graph
                  firstColumn="Manufacturers"
                  secondColumnPrimary="Share"
                  secondColumnSecondary="%"
                  thirdColumnPrimary="YoY"
                  thirdColumnSecondary="% Chg"
                  dateRange={marketShare.dateRange}
                  dateRangeType={
                    timePeriod.name === 'This Quarter' ||
                    timePeriod.name === 'Last Quarter'
                      ? 'week'
                      : 'month'
                  }
                  seriesData={
                    shareTop5
                      ? marketShare.marketSharesTable.top5SharesPlotData
                      : marketShare.marketSharesTable.closest5SharesPlotData
                  }
                  tableData={
                    shareTop5
                      ? marketShare.marketSharesTable.top5SharesTrendTables
                      : marketShare.marketSharesTable.closest5SharesTrendTables
                  }
                  upperBound={`${
                    shareTop5
                      ? marketTopSharesUpperBound
                      : marketClosestSharesUpperBound
                  }%`}
                  onDataClick={this.handleDataClick}
                  onShare={() => this.handleOverlayAnimation('showCard')}
                  isLoading={marketSalesLoading}
                />
              </div>,
              'shareTop5'
            )}
            {/* WATCHLIST SECTION */}
            <div className={styles.watchListContainer}>
              <div className={styles.watchListHeader}>
                <p>MY WATCHLIST</p>
                <div>
                  <img
                    onClick={() => this.handleOverlayAnimation('showShare')}
                    alt="share-button"
                    src={shareButton}
                  />
                  <a href="/feature">Edit</a>
                </div>
              </div>
              <SmallCarousel cards={watchListCards} />
            </div>
          </div>
          <ToTop />
        </>
      </div>
    );
  };

  render() {
    return <this.homeContainer />;
  }
}

Home.propTypes = {
  setMarketViewPosition: PropTypes.func.isRequired,
  setAllPortfolioFilters: PropTypes.func.isRequired,
  filterObject: {
    timePeriod: {
      start: PropTypes.func.isRequired,
      end: PropTypes.func.isRequired,
    },
    portfolio: {
      name: PropTypes.string.isRequired,
      uuid: PropTypes.string.isRequired,
    },
  },
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

const mapStateToProps = (state) => {
  const { filterPosition, filterObject, viewCheck } = state.elements;

  const { storedData, version } = state.data;

  return { filterPosition, filterObject, viewCheck, storedData, version };
};

const mapDispatchToProps = (dispatch) => ({
  setStoredData: (value) => dispatch(dataActions.setStoredData(value)),
  setMarketViewPosition: (value) =>
    dispatch(elementsActions.setMarketViewPosition(value)),
  setAllPortfolioFilters: (value) =>
    dispatch(elementsActions.setAllPortfolioFilters(value)),
  setFilterObject: (value) => dispatch(elementsActions.setFilterObject(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
